import Card from "../UI/Card";
import ExpenseItem from "./ExpenseItem";

import styles from "./ExpenseList.module.css";
const ExpenseList = (props) => {
  const { expenseData } = props;
  return (
    <Card>
      <ul
        className={styles["expenses-expenseList"]}
      >
        {expenseData.map((expense) => {
          return (
            <ExpenseItem
              key={expense.id}
              expenseData={expense}
            />
          );
        })}
      </ul>
    </Card>
  );
};

export default ExpenseList;
